import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function AllRooms() {
    const navigate = useNavigate();
    useEffect(() => {
        const scriptUrls = [
            '/assets/js/jquery.min.js',
            '/assets/js/bootstrap.bundle.min.js',
            '/assets/js/moment.min.js',
            '/assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
            '/assets/vendor/overlay-scroll/custom-scrollbar.js',
            '/assets/vendor/daterange/daterange.js',
            '/assets/vendor/daterange/custom-daterange.js',
            '/assets/vendor/jquery-ui/jquery-ui.min.js',
            '/assets/vendor/jquery-ui/custom.js',
            '/assets/vendor/datatables/dataTables.min.js',
            '/assets/vendor/datatables/dataTables.bootstrap.min.js',
            '/assets/vendor/datatables/custom/custom-datatables.js',
            '/assets/js/custom.js',


        ];

        let isCancelled = false;

        const loadScriptsSequentially = async () => {
            for (const url of scriptUrls) {
                if (isCancelled) break;

                await new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            }
        };

        loadScriptsSequentially();

        return () => {
            isCancelled = true;
        };
    }, []);
    const handleSubmit = () => {
        // Optional: Add form validation logic here
        navigate("/available-rooms");
        setTimeout(() => {
            window.location.reload(); // force page refresh after navigation
        }, 100);
    };
    return (<>
        <div className="app-container">
                    {/* App header starts */}


                    {/* App hero header starts */}
                    <div className="app-hero-header d-flex align-items-center">
                        {/* Breadcrumb starts */}
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="index-2.html">
                                    <i className="ri-home-3-line" />
                                </a>
                            </li>
                            <li className="breadcrumb-item">Rooms</li>
                            <li className="breadcrumb-item text-primary" aria-current="page">
                                All Rooms 
                            </li>
                        </ol>
                        {/* Breadcrumb ends */}
                        {/* Sales stats starts */}
                        <div className="ms-auto d-lg-flex d-none flex-row">
                            <div className="input-group">
                                <span className="input-group-text bg-primary-lighten">
                                    <i className="ri-calendar-2-line text-primary" />
                                </span>
                                <input type="text" id="abc" className="form-control custom-daterange" />
                            </div>
                        </div>
                        {/* Sales stats ends */}
                    </div>
                    {/* App Hero header ends */}
                    {/* App body starts */}
                    <div className="app-body">
                        {/* Row starts */}
                        <div className="row gx-4">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">All Rooms</h5>
                                    </div>
                                    <div className="card-body">
                                        {/* Table starts */}
                                        <div className="table-outer">
                                            <div className="table-responsive">
                                                <table className="table truncate align-middle m-0">
                                                    <thead>
                                                        <tr>
                                                            <th width="100px">Department</th>
                                                            <th width="60px">Room No</th>
                                                            <th width="60px">Bed No</th>
                                                            <th width="100px">Patient</th>
                                                            <th width="100px">Admit Date</th>
                                                            <th width="100px">Age</th>
                                                            <th width="100px">Gender</th>
                                                            <th width="100px">Room Type</th>
                                                            <th width="100px">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Endocrinology</td>
                                                            <td>301</td>
                                                            <td>3</td>
                                                            <td>James Macias</td>
                                                            <td>12/07/2024</td>
                                                            <td>65</td>
                                                            <td>Male</td>
                                                            <td><span className="badge border border-success text-success">Delux</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Pathology</td>
                                                            <td>810</td>
                                                            <td>2</td>
                                                            <td>Liza Morrison</td>
                                                            <td>26/05/2024</td>
                                                            <td>31</td>
                                                            <td>Female</td>
                                                            <td><span className="badge border border-success text-success">Delux</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cardiology</td>
                                                            <td>608</td>
                                                            <td>2</td>
                                                            <td>Jerold Rich</td>
                                                            <td>30/06/2024</td>
                                                            <td>22</td>
                                                            <td>Male</td>
                                                            <td><span className="badge border border-info text-info">Standard</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Anatomy</td>
                                                            <td>507</td>
                                                            <td>1</td>
                                                            <td>Kim Crosby</td>
                                                            <td>14/05/2024</td>
                                                            <td>71</td>
                                                            <td>Male</td>
                                                            <td><span className="badge border border-primary text-primary">Private</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Gastroenterology</td>
                                                            <td>212</td>
                                                            <td>4</td>
                                                            <td>Helena Moyer</td>
                                                            <td>18/06/2024</td>
                                                            <td>29</td>
                                                            <td>Female</td>
                                                            <td><span className="badge border border-success text-success">Delux</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Neurology</td>
                                                            <td>408</td>
                                                            <td>1</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td><span className="badge border border-info text-info">Standard</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Orthopedics</td>
                                                            <td>503</td>
                                                            <td>3</td>
                                                            <td>Joni Hull</td>
                                                            <td>12/06/2024</td>
                                                            <td>36</td>
                                                            <td>Female</td>
                                                            <td><span className="badge border border-warning text-warning">Suite</span></td>
                                                            <td>
                                                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#dischargeNow">Edit</button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* Table ends */}
                                        {/* Modal Delete Row */}
                                        <div className="modal fade" id="dischargeNow" tabIndex={-1} aria-labelledby="dischargeNowLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-sm">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="dischargeNowLabel">
                                                            Confirm
                                                        </h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                    </div>
                                                    <div className="modal-body">
                                                        Are you sure you want to Edit?
                                                    </div>
                                                    <div className="modal-footer">
                                                        <div className="d-flex justify-content-end gap-2">
                                                            <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                                            <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">Yes</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Row ends */}
                    </div>
                    {/* App body ends */}
                   
                </div>
    </>)
}
export default AllRooms;